import { takeLatest, call, put } from 'redux-saga/effects';

import { statusCodes } from 'modules/common/enums';
import {
  addMasterService,
  deleteMasterService,
  editMasterService,
  getCategories,
  getMasterServicesList,
} from './api';
import {
  fetchMasterServicesListSuccess,
  fetchMasterServicesListFail,
  addOrEditMasterServiceSuccess,
  addOrEditMasterServiceFail,
  deleteMasterServiceSuccess,
  deleteMasterServiceFail,
  fetchCategoriesSuccess,
  fetchCategoriesFail,
} from './actions';
import masterServicesActionTypes from './action-types';

function* fetchMasterServicesListSaga({ payload }) {
  try {
    const response = yield call(getMasterServicesList, payload);
    yield put(fetchMasterServicesListSuccess(response.data.data));
  } catch (error) {
    yield put(fetchMasterServicesListFail(error));
  }
}

function* addOrEditMasterServiceSaga({ payload }) {
  const { callbackAction, data } = payload;
  try {
    const { MasterServiceKey } = data;
    if (MasterServiceKey) yield call(editMasterService, data);
    else yield call(addMasterService, data);
    callbackAction();
    yield put(addOrEditMasterServiceSuccess());
  } catch (error) {
    if (error?.response?.status === statusCodes.conflict)
      yield put(addOrEditMasterServiceFail('A Master Service with this Name already exists!'));
  }
}

function* deleteMasterServiceSaga({ payload }) {
  const { callbackAction, data } = payload;
  try {
    yield call(deleteMasterService, data);
    callbackAction();
    yield put(deleteMasterServiceSuccess());
  } catch (error) {
    if (error?.response?.status === statusCodes.forbidden)
      yield put(deleteMasterServiceFail('Must Delete Linked Services First!'));
  }
}

function* fetchCategoriesSaga({ payload }) {
  try {
    const response = yield call(getCategories, payload);
    yield put(fetchCategoriesSuccess(response.data.data));
  } catch (error) {
    yield put(fetchCategoriesFail(error));
  }
}

function* masterServicesSaga() {
  yield takeLatest(
    masterServicesActionTypes.FETCH_MASTERSERVICES_LIST,
    fetchMasterServicesListSaga,
  );
  yield takeLatest(
    masterServicesActionTypes.ADD_OR_EDIT_MASTER_SERVICE,
    addOrEditMasterServiceSaga,
  );
  yield takeLatest(masterServicesActionTypes.DELETE_MASTER_SERVICE, deleteMasterServiceSaga);
  yield takeLatest(masterServicesActionTypes.FETCH_CATEGORIES, fetchCategoriesSaga);
}

export default masterServicesSaga;
